import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import TheMask from 'vue-the-mask';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';

import dayjs from '@/plugins/dayjs';
import vmoney from '@/plugins/vmoney';

import { createPinia } from 'pinia';

const appName = window.location?.hostname?.includes('portal') ? 'Netisa CRM' : window.location?.hostname?.includes('sakura') ? 'Sakura Bayi' : 'Netisa Bayi';

// change favicon based on hostname
document.querySelector('link[rel="icon"]').href = window.location?.hostname?.includes('portal') ? '/crm-favicon.ico' : window.location?.hostname?.includes('sakura') ? '/partner-favicon.ico' : '/crm-favicon.ico';

const pinia = createPinia();

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(pinia)
            .use(ZiggyVue)
            .use(TheMask)
            .use(VueTelInput, {
                defaultCountry: 'TR',
                preferredCountries: ['TR'],
                mode: 'international',
                inputOptions: {
                    // showDialCode: true,
                    autocomplete: 'tel',
                    placeholder: 'Telefon Numarası',
                },
                dropdownOptions: {
                    showFlags: true,
                    showDialCodeInSelection: false,
                },
            })
            .use(dayjs)
            .use(vmoney)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

console.warn = () => {};
